import { render } from "./ExistingABProductsComponent.vue?vue&type=template&id=3312f32e&ts=true"
import script from "./ExistingABProductsComponent.ts?vue&type=script&lang=ts"
export * from "./ExistingABProductsComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__